import * as React from 'react';
import DocumentTitle from 'react-document-title';

import { CrossPitches } from '../components/cross-pitches';
import { Header } from '../components/header';

export const CrossPitchesPage: React.FC = () => (
    <DocumentTitle title="Cross Pitches Leaderboard">
        <div id="container">
            <Header title="Cross Pitches Leaderboard" />
            <div id="content" className="flex-fill">
                <CrossPitches />
            </div>
        </div>
    </DocumentTitle>
);
